'use client'

import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext } from 'react'
import { useDirectoryNavigationManger } from '@/features/drive/functionalities/navigation/use-directory-navigation'

type IDirectoryNavigationContext = ReturnType<typeof useDirectoryNavigationManger>

const DirectoryNavigationContext = createContext<IDirectoryNavigationContext | null>(null)

type IDirectoryNavigationContextProviderProps = IChildrenProps

export const DirectoryNavigationContextProvider = ({ children }: IDirectoryNavigationContextProviderProps) => {
    const navigationManger = useDirectoryNavigationManger()

    return (
        <DirectoryNavigationContext.Provider value={{ ...navigationManger }}>
            {children}
        </DirectoryNavigationContext.Provider>
    )
}

export const useDirectoryNavigationContext = () => {
    const context = useContext(DirectoryNavigationContext)

    if (!context) {
        if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production') {
            throw new Error('DirectoryNavigationContext not found')
        } else {
            console.log('DirectoryNavigationContext not found')
        }
    }

    return (context || {}) as IDirectoryNavigationContext
}
